import { SchedulerGridHeader } from './header';
import { SchedulerGridWithoutTeam } from './withoutTeam';
import { SchedulerGridForemen } from './foremen';
import { GRID_TEMPLATE_COLUMNS } from './constants';
import { useSchedulerContext } from '@contexts/scheduler';
import { cn } from '@utils/cn';
import { useSchedulerResize } from '@hooks/scheduler/resize';
import { useDroppable } from '@dnd-kit/core';

export const SchedulerGrid = () => {
  const { handlePointerUp, handlePointerMove, handlePointerLeave } = useSchedulerResize();

  const { setNodeRef } = useDroppable({ id: 'scheduler' });

  const {
    active: { cursor },
  } = useSchedulerContext();

  return (
    <div
      ref={setNodeRef}
      className={cn(['relative grid', cursor])}
      onPointerUp={handlePointerUp}
      onPointerMove={handlePointerMove}
      onPointerLeave={handlePointerLeave}
      style={GRID_TEMPLATE_COLUMNS}>
      <SchedulerGridHeader />
      <SchedulerGridWithoutTeam />
      <SchedulerGridForemen />
    </div>
  );
};
